// @flow
import { useEffect, useState } from 'react'

let reopenBanner = null
const listeners = new Set()

const notifyListeners = () => {
  listeners.forEach(listener => listener(!!reopenBanner))
}

export const registerBannerReopen = (reopen: () => void) => {
  reopenBanner = reopen
  notifyListeners()

  return () => {
    if (reopenBanner === reopen) {
      reopenBanner = null
      notifyListeners()
    }
  }
}

export const reopenCookieBanner = () => {
  reopenBanner && reopenBanner()
}

export const useCanReopenBanner = () => {
  const [canReopen, setCanReopen] = useState(false)

  useEffect(() => {
    listeners.add(setCanReopen)
    setCanReopen(!!reopenBanner)

    return () => {
      listeners.delete(setCanReopen)
    }
  }, [])

  return canReopen
}
